import * as React from 'react';

import { atom, useAtomValue } from 'jotai';

import { translate } from '~l10n/client';
import { Dialog } from '~shared/components/Dialog';
import { Pending } from '~teacher/components/ExportReports/ExportFeedback/ExportFeedbackIcons';
import {
  CurrentQuizEditorDialog,
  currentQuizEditorDialogAtom,
} from '~teacher/components/QuizEditor/atoms/currentQuizEditorDialogAtom';
import { ImportFromText } from '~teacher/components/QuizEditor/ImportFromTextDialog/ImportFromText';
import { HideIntercomLauncher } from '~teacher/hook/utils/HideIntercomLauncher';

export const positionAtom = atom(1);

interface Props {
  onClose: () => void;
  onSuccess: () => void;
}

export function ImportFromTextDialog({ onClose, onSuccess }: Props) {
  const currentQuizEditorDialog = useAtomValue(currentQuizEditorDialogAtom);

  return (
    <Dialog
      position="right"
      showBackdrop={false}
      size="medium"
      open={currentQuizEditorDialog === CurrentQuizEditorDialog.ImportFromText}
      onClose={onClose}
      id={'generate-quiz-dialog'}
      title={translate('Copy-Paste Questions')}
      closeLabel={translate('Close')}
      disableBackdropClose
    >
      {() =>
        currentQuizEditorDialog === CurrentQuizEditorDialog.ImportFromText ? (
          <>
            <HideIntercomLauncher />
            <ImportFromText onSuccess={onSuccess} />
          </>
        ) : (
          <div className="grid items-center justify-center h-full">
            <div className="flex flex-col items-center gap-8">
              <Pending />
            </div>
          </div>
        )
      }
    </Dialog>
  );
}
